// extracted by mini-css-extract-plugin
export var formSection = "DesktopEmbed-module--formSection--1Z-vQ";
export var inputWrapper = "DesktopEmbed-module--inputWrapper--uBBCs";
export var inputContainer = "DesktopEmbed-module--inputContainer---lYrG";